import React, { useEffect } from "react";
import { ImageOff, Plus } from "lucide-react";

import { registrarExibidas } from "./metricas";

const reais = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

// Faixa horizontal de sugestões. `precoDe(produto)` devolve { preco, cheio } com promoção
// e oferta do cliente; `fotoDe(url)` resolve a foto. Conta "exibida" ao aparecer.
export default function ListaSugestoes({ lugar, titulo, itens, onEscolher, precoDe, fotoDe, darkMode, compacto = false }) {
  const ids = itens.map((s) => s.id).join(",");
  useEffect(() => {
    if (ids) registrarExibidas(lugar, ids.split(","));
  }, [lugar, ids]);
  if (!itens.length) return null;
  const texto = darkMode ? "text-white" : "text-gray-900";
  const suave = darkMode ? "text-zinc-400" : "text-gray-500";
  return (
    <div data-e2e={`sugestoes-${lugar}`}>
      {titulo && <p className={`text-[11px] uppercase tracking-wider font-bold mb-1.5 ${suave}`}>{titulo}</p>}
      <div className="flex gap-2 overflow-x-auto pb-1 snap-x" style={{ scrollbarWidth: "thin" }}>
        {itens.map((s) => {
          const { preco, cheio } = precoDe(s.produto);
          const foto = fotoDe(s.produto.photo_url);
          return (
            <button key={s.id} type="button" onClick={() => onEscolher(s, lugar)} data-e2e="sugestao"
              className={`relative shrink-0 snap-start rounded-xl border overflow-hidden text-left transition-transform active:scale-95 ${darkMode ? "border-zinc-700 bg-zinc-800/70" : "border-gray-200 bg-white"}`}
              style={{ width: compacto ? 112 : "clamp(104px, 30vw, 132px)" }} aria-label={`Adicionar ${s.produto.name}`}>
              <div className={`w-full aspect-square overflow-hidden flex items-center justify-center ${darkMode ? "bg-zinc-900" : "bg-gray-100"}`}>
                {foto ? <img src={foto} alt="" className="w-full h-full object-cover" loading="lazy" onError={(e) => { e.currentTarget.style.display = "none"; }} />
                  : <ImageOff className={`w-7 h-7 ${suave}`} strokeWidth={1.5} />}
              </div>
              {s.oferta && <span className="absolute top-1 left-1 rounded-full bg-primary text-primary-foreground text-[9px] font-black uppercase px-1.5 py-0.5">Sua oferta</span>}
              <span className="absolute top-1 right-1 w-6 h-6 rounded-full bg-orange-500 text-white flex items-center justify-center shadow-md"><Plus className="w-4 h-4" strokeWidth={3} /></span>
              <div className="p-1.5">
                <p className={`text-[11px] font-semibold leading-tight line-clamp-2 min-h-[1.75rem] ${texto}`}>{s.produto.name}</p>
                <p className="text-[11px] font-bold text-orange-500 tabular-nums">
                  {cheio && cheio > preco ? <span className={`line-through font-normal mr-1 ${suave}`}>{reais(cheio)}</span> : null}{reais(preco)}
                </p>
                <p className={`text-[9px] leading-tight mt-0.5 line-clamp-2 ${suave}`}>{s.motivo}</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
